import { type CSSProperties, forwardRef, type PropsWithChildren } from 'react';
import { styled } from 'styled-components';
import { cssLimitTextToLines } from '../styles/styles.js';

type FuuzeTextProps = PropsWithChildren<{
  variant?: 'body' | 'h1' | 'h2' | 'body2';
  bold?: boolean;
  style?: CSSProperties;
  maxLines?: number;
}>;

export const FuuzeText = styled.p<{ $bold?: boolean; $maxLines?: number }>`
  font-weight: ${props => (props.$bold ? 'bold' : 'normal')};
  color: ${props => props.color || props.theme.colors.text};
  ${props => props.$maxLines && cssLimitTextToLines(props.$maxLines)}
`;

// export const FuuzeText = forwardRef<HTMLParagraphElement, FuuzeTextProps>(
//   ({ bold, variant, style, children, maxLines, ...props }, ref) => {
//     const as = variant === 'body' ? 'p' : variant === 'body2' ? 'small' : variant
//
//     return (
//       <Component {...props} ref={ref} as={as} $variant={variant} $bold={bold} $maxLines={maxLines} style={style}>
//         {children}
//       </Component>
//     )
//   },
// )
//
// const Component = styled.p<{ $variant?: 'body' | 'h1' | 'h2' | 'body2'; $bold?: boolean; $maxLines?: number }>`
//   //font-size: ${(props) => props.theme.typography[props.$variant || 'body'].fontSize}px;
//   font-weight: ${(props) => (props.$bold ? 'bold' : 'normal')};
//   color: ${(props) => props.theme.colors.text};
//   ${(props) => props.$maxLines && cssLimitTextToLines(props.$maxLines)}
// `
